export const UIActionsList = {
    SET_SENT: 'SET_SENT'
}

export const setSent = () => {
    return {
        type: UIActionsList.SET_SENT
    }
}
